import Constant from '../lib/constant';
import axiosClient from './axiosClient';

const url = Constant.apiUrl + '/common/upload';
const uploadApi = {
	uploadImage: (body) => {
		return axiosClient.post(
			url + '/cloud/image',
			{ file: body },
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		);
	},
	uploadVideo: (body) => {
		return axiosClient.post(
			url + '/cloud/video',
			{ file: body },
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		);
	},
	uploadImages: (body) => {
		// body.map((x) => console.log(x));
		console.log({ body });

		return axiosClient.post(
			url + '/cloud/images',
			{
				files: body,
			},
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		);
	},
	update: (id, body) => {
		return axiosClient.put(url + `${id}`, body);
	},
};
export default uploadApi;
